module.exports = __webpack_public_path__ + "static/media/tel.7fb55219.svg";